module.exports = __webpack_public_path__ + "static/media/clock.47f59430.png";